import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo-black.png'
import _imports_1 from '@/assets/img/illustration-login.png'
import _imports_2 from '@/assets/img/logo-mg.png'


const _hoisted_1 = { class: "login background-white absolute" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col items-center justify-evenly lg:hidden px-10 mt-16 mb-3 top-info" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "h-6 mb-5",
    alt: "logo"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "font-bold text-4xl text-center" }, "SELAMAT DATANG REKAN MIISI"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-center" }, "Tingkatkan kemudahan dan kecepatan pengiriman produk Anda bersama MIISI")
], -1)
const _hoisted_3 = { class: "flex w-full items-stretch" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"image-left lg:w-4/6 hidden lg:block relative\"><div class=\"flex flex-col items-center justify-between wrap pt-14\"><img src=\"" + _imports_0 + "\" class=\"h-6 self-start mb-39\" alt=\"logo\"><div class=\"flex flex-col items-center info py-3 mt-16\"><img src=\"" + _imports_1 + "\" alt=\"logo\"><div class=\"mt-10 font-bold text-4xl\">SELAMAT DATANG REKAN MIISI</div><div class=\"text-2xl\">Tingkatkan kemudahan dan kecepatan pengiriman produk Anda bersama MIISI</div></div><img src=\"" + _imports_2 + "\" class=\"mb-3\" alt=\"logo-mg\"></div></div>", 1)
const _hoisted_5 = { class: "form w-full lg:w-2/6 flex flex-col justify-between" }
const _hoisted_6 = { class: "wrap" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "text-white font-bold text-3xl flex items-center mb-2" }, " Atur Ulang Password ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, "kami akan mengirimkan link ke email yang anda berikan untuk mengatur ulang kata sandi anda . Pastikan sebelumnya telah terdaftar dalam anggota MIISI", -1)
const _hoisted_9 = { class: "p-fluid" }
const _hoisted_10 = { class: "p-field mb-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "text-white"
}, "Kata Sandi", -1)
const _hoisted_12 = { class: "invalid-feedback" }
const _hoisted_13 = { class: "p-field mb-6" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "confirmPassword",
  class: "text-white"
}, "Konfirmasi Kata Sandi", -1)
const _hoisted_15 = { class: "invalid-feedback" }
const _hoisted_16 = { class: "text-center text-white font-semibold text-xs" }

import {
  ref,
  onMounted,
  getCurrentInstance,
  reactive
} from 'vue'
import ButtonSecondary from '@/views/components/button/ButtonSecondary.vue'
import InputText from 'primevue/inputtext'
import HjpAlertModal from '@/views/components/modal/HjpAlertModal.vue'
import { useRouter, useRoute } from 'vue-router'
import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePassword',
  setup(__props) {

const loading = ref(false)
const router = useRouter()
const version = localStorage.getItem('version')

const attrModalConfirmation = reactive({
  show: false,
  title: 'Kata Sandi Berhasil Diatur Ulang',
  subTitle: 'Kata sandi anda telah berhasil diatur ulang oleh sistem. Silahkan masuk untuk melanjutkan',
  btnSubmitTitle: 'Masuk',
  imgContent: require('@/assets/img/icon/reset-password.svg'),
})

const schema = Yup.object().shape({
  password: Yup.string().required('Password harus diisi'),
  confirmPassword: Yup.string().oneOf([Yup.ref('password')], 'Password tidak sama')
})

const initialValues = {
  password: 'password',
  confirmPassword: 'password'
}

const onSubmit = (values: any) => {
  console.log('masukk submit', values)
  loading.value = true
  attrModalConfirmation.show = true
}

const hideDialog = () => {
  loading.value = false
  attrModalConfirmation.show = false
}

const toPage = (val: any) => {
  console.log('val', val)
  router.push({
    name: val
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _hoisted_8,
          _createVNode(_unref(Form), {
            onSubmit: onSubmit,
            "validation-schema": _unref(schema),
            "initial-values": initialValues,
            class: "pb-16 pt-10 w-full"
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_unref(Field), { name: "password" }, {
                    default: _withCtx(({ handleChange, handleBlur, field }) => [
                      _createVNode(_unref(InputText), _mergeProps({
                        onChange: handleChange,
                        onBlur: handleBlur,
                        autofocus: "",
                        class: `input-primary`,
                        placeholder: "Masukkan kata sandi Anda"
                      }, field), null, 16, ["onChange", "onBlur"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(errors.password), 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_unref(Field), { name: "confirmPassword" }, {
                    default: _withCtx(({ handleChange, handleBlur, field }) => [
                      _createVNode(_unref(InputText), _mergeProps({
                        onChange: handleChange,
                        onBlur: handleBlur,
                        autofocus: "",
                        class: `input-primary`,
                        placeholder: "Masukkan konfirmasi kata sandi Anda"
                      }, field), null, 16, ["onChange", "onBlur"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(errors.confirmPassword), 1)
                ])
              ]),
              _createVNode(ButtonSecondary, {
                classList: 'btn-size-lg',
                buttonText: 'Reset Kata Sandi',
                id: "submit-login",
                type: "submit",
                disabled: loading.value
              }, null, 8, ["disabled"])
            ]),
            _: 1
          }, 8, ["validation-schema"])
        ]),
        _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(version)), 1)
      ])
    ]),
    _createVNode(HjpAlertModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      onHideDialog: hideDialog,
      onOnSubmit: _cache[0] || (_cache[0] = ($event: any) => (toPage('Login')))
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle"])
  ]))
}
}

})